import * as React from "react";
import { isWeb } from "~/utils/platform";

export const useReferralFromUrl = () => {
  const [referral, setReferral] = React.useState<string>("");
  const [path, setPath] = React.useState<string>("");

  React.useEffect(() => {
    if (isWeb) {
      const urlParams = new URLSearchParams(window.location.search);
      const referralParam = urlParams.get("referral");
      setReferral(referralParam ?? "");
      setPath(window.location.pathname);
    }
  }, []);

  return { referral, path };
};
